/**
 * The one bridge from engine stores into React (CLAUDE.md rule 3).
 *
 * Every engine store returns immutable, identity-stable snapshots, so
 * `useSyncExternalStore` needs no selectors or cloning here. Specific hooks
 * (`useSelection`, `useEntity`, …) are thin wrappers around this.
 */
import { useSyncExternalStore } from "react";
import type { ReadableStore } from "../../core/store";

export function useStore<T>(store: ReadableStore<T>): T {
  return useSyncExternalStore(store.subscribe, store.getSnapshot);
}
